import { get, isUndefined } from 'lodash'

export default {
  'PTN-HS': (user) => {
    return (
      !isUndefined(user.StudentRequirements.PotentialHighSchool) && !get(user, 'Preferences.PotentialHighSchool', false)
    )
  },
}
